/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useEffect } from 'react';
import AutoCompleteWidget from './AutoCompleteWidget';
import { useAutocomplete } from '../../../redux/features/autocomplete/useAutocomplete';

const AutocompleteField = (props) => {
  const {
    configuration,
    children,
    category,
    value,
    inputValue,
    updateCurrentInput,
    updateCurrentValue,
    onChoiceSelected,
    labelKey,
    onChange,
    formData,
  } = props;

  const { options, current, getOptions, getSelectedOption, resetAutocomplete } = useAutocomplete({ configuration });

  useEffect(() => {
    // on mount populate Options
    const initAutocomplete = async () => {
      const { payload } = await getOptions(category);
      // if there is value at first render we handle edit case
      if (formData && payload) {
        const preselectedValue = payload.find(e => e.id === formData);
        updateCurrentValue(preselectedValue);
      }
    };
    initAutocomplete();

    return () => {
      // clear store
      resetAutocomplete();
    };
  }, []);

  useEffect(() => {
    // when current patent updated
    // we need to update all fields in section
    if (current) {
      onChoiceSelected(current);
    }
  }, [current]);

  useEffect(() => {
    // get details for current
    if (value && inputValue) {
      const { id } = value;
      getSelectedOption(category, id);
      onChange(id);
    }
  }, [value]);

  return (
    <>
      <AutoCompleteWidget
        value={value}
        setValue={updateCurrentValue}
        inputValue={inputValue}
        setInputValue={updateCurrentInput}
        options={options}
        onGetLabel={option => option[labelKey]}
        {...props}
      />
      {children}
    </>
  );
};

export default AutocompleteField;
